import { IPostalCodeImport } from '../Models';

const headers = new Headers();
headers.append('Accept-Language', document.querySelector('html')!.lang);
headers.append('Content-Type', 'application/json');

export const PostalCodesService = {
    async getAllPostalCodes(): Promise<IPostalCodeImport[]> {
        const response = await fetch('/Api/PostalCodes/GetAll/');
        return await response.json();
    },
};
